var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container-index"
  }, [_c("div", {
    staticClass: "bg"
  }, [_c("img", {
    staticClass: "default",
    style: "height:100%;transform: translateX(" + _vm.num + "px);transition: transform 5s;-moz-transition: transform 5s;-webkit-transition: transform 5s;-o-transition: transform 5s;",
    attrs: {
      src: "https://tpage.soimt.com/APP/SNS/sns_bg.png",
      alt: ""
    },
    on: {
      load: _vm.loadImage
    }
  })]), _vm._m(0), _vm._m(1), _vm._m(2), _c("div", {
    staticClass: "btn",
    on: {
      click: _vm.toLogin
    }
  }, [_vm._v("Connect using Phone/Mobile")])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title"
  }, [_c("img", {
    staticClass: "top",
    attrs: {
      src: require("../assets/images/MG_1.png"),
      alt: ""
    }
  }), _c("img", {
    staticClass: "bottom",
    attrs: {
      src: require("../assets/images/iSMART.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "btn-con"
  }, [_c("div", {
    staticClass: "google"
  }, [_c("img", {
    attrs: {
      src: require("../assets/images/google-logo.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("Google")])]), _c("div", {
    staticClass: "facebook"
  }, [_c("img", {
    attrs: {
      src: require("../assets/images/facebook-logo.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("Facebook")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "txt-con"
  }, [_c("span", {
    staticClass: "line"
  }), _c("span", {
    staticClass: "txt"
  }, [_vm._v("Or use your mobile/email")]), _c("span", {
    staticClass: "line"
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };